module.exports = __webpack_public_path__ + "img/fondo-banner-principal.40f45498.png";